<!--
  navItem "Übersicht" of the Provisionsmatrix — the header on top, the matrix rows below.

  THE DRAWER LAYOUT CONTRACT is the one class group `max-h-30rem overflow-y-auto overflow-x-auto`
  on the row block of the compact variant:

    * the table brings its OWN scroll container, horizontally as well as vertically — a row that is
      too wide therefore scrolls INSIDE the drawer instead of pushing the drawer or the page behind
      it sideways;
    * its height is capped, so the drawer height the host prescribes is not blown up;
    * `max-h-30rem` rather than a `vh` value: the application's UI scaling rewrites the root font
      size at runtime, so a rem bound grows and shrinks with it — the same reasoning as in
      `cw-consultation-doc-closure-bar.component.html`.

  In the full view there is no cap: there the height belongs to the page.
-->
<div class="cp-provision-type-matrix-overview">

    @if (!initialized) {

        <p-skeleton height="16rem"></p-skeleton>

    } @else if (!provisionTypeMatrixId) {

        <p-message severity="info"
                   text="Keine Provisionsmatrix ausgewählt."
                   styleClass="w-full">
        </p-message>

    } @else {

        @if (matrixWidget) {
            <mvs-widget [widgetData]="matrixWidget"
                        [importObjectContext]="importContext">
            </mvs-widget>
        }

        <!--
          `[disableUpdate]="compact"` IS the implementation of FD-6: in the drawer it suppresses the
          table's "Anlegen" menu entry (`mvs-widget.component.ts:313` drops the keys add/change/show
          — of which a table widget only ever offers `add`), while the full view keeps it.

          The pre-fill of the mandatory FK does NOT hang off this: it sits on the widget's
          `functionCallbacks` in BOTH modes. Withholding those callbacks would NOT remove the
          button, only its pre-fill.
        -->
        @if (rowsWidget) {
            <div class="mt-3"
                 [class.max-h-30rem]="compact"
                 [class.overflow-y-auto]="compact"
                 [class.overflow-x-auto]="compact">
                <mvs-widget [widgetData]="rowsWidget"
                            [importObjectContext]="importContext"
                            [disableUpdate]="compact">
                </mvs-widget>
            </div>
        }

    }

</div>
